'use client';
'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var tailwindMerge = require('tailwind-merge');
var TextFieldContainer = require('../TextFieldContainer/TextFieldContainer.js');
var SupportTextContainer = require('../SupportTextContainer/SupportTextContainer.js');
require('../Input/Input.js');
require('../Input/PasswordInput.js');
var LableInput = require('../Input/LableInput.js');
var InputTypeSelector = require('../Input/InputTypeSelector.js');

/**
 * 사용자 입력을 받을 수 있는 텍스트 필드 컴포넌트입니다.
 *
 * @component
 * @param {Object} props - 컴포넌트 props
 * @param {'default' | 'lable'} [props.variant='default'] - 텍스트 필드의 변형 타입
 * @param {string} [props.lable] - 입력 필드의 라벨
 * @param {boolean} [props.isError] - 오류 상태 표시 여부
 * @param {MediumSystemIconName} [props.startIcon] - 시작 부분에 표시될 아이콘
 * @param {MediumSystemIconName} [props.endIcon] - 끝 부분에 표시될 아이콘
 * @param {string} [props.supportMessage] - 도움말 메시지
 * @param {string} [props.measure] - 측정 단위
 * @param {string} [props.errorMessage] - 오류 메시지
 * @param {string} [props.testId] - 테스트용 ID
 * @param {boolean} [props.isMaxLengthVisible=false] - 최대 길이 표시 여부
 *
 * @example
 * // 기본 텍스트 필드
 * <TextField
 *   placeholder="이름을 입력하세요"
 *   onChange={(e) => handleChange(e)}
 * />
 *
 * // 라벨이 있는 텍스트 필드
 * <TextField
 *   variant="lable"
 *   lable="이름"
 *   placeholder="홍길동"
 *   startIcon="user"
 *   supportMessage="실명을 입력해주세요"
 * />
 *
 * // 에러 상태의 텍스트 필드
 * <TextField
 *   variant="default"
 *   isError={true}
 *   errorMessage="필수 입력 항목입니다"
 *   maxLength={50}
 *   isMaxLengthVisible={true}
 * />
 */ const TextField = react.forwardRef((_a, ref)=>{
    var { type, name, value, onChange, maxLength, disabled = false, placeholder, lable, testId, measure, isError, endIcon, startIcon, errorMessage, supportMessage, variant = 'default', isMaxLengthVisible = false, className } = _a, rest = _tslib.__rest(_a, [
        "type",
        "name",
        "value",
        "onChange",
        "maxLength",
        "disabled",
        "placeholder",
        "lable",
        "testId",
        "measure",
        "isError",
        "endIcon",
        "startIcon",
        "errorMessage",
        "supportMessage",
        "variant",
        "isMaxLengthVisible",
        "className"
    ]);
    const [isFocused, setIsFocused] = react.useState(false);
    const [currentLength, setCurrentLength] = react.useState(0);
    const onFocus = ()=>{
        setIsFocused(true);
    };
    const onBlur = ()=>{
        setIsFocused(false);
    };
    const commonProps = Object.assign({
        variant,
        type,
        name,
        value,
        placeholder,
        lable,
        maxLength,
        onChange,
        isFocused,
        isError,
        onFocus,
        onBlur,
        disabled
    }, rest);
    const isVisibleSupportContainer = isError || supportMessage || isMaxLengthVisible;
    react.useEffect(()=>{
        if (typeof value === 'string' && maxLength) {
            setCurrentLength(value.length);
        }
    }, [
        value,
        maxLength
    ]);
    return jsxRuntime.jsxs("div", {
        className: tailwindMerge.twMerge('flex min-w-fit select-none flex-col gap-2 tracking-default', className),
        "data-testid": testId,
        children: [
            jsxRuntime.jsx("label", {
                role: "input-box",
                className: !disabled ? 'cursor-text' : 'cursor-not-allowed',
                children: jsxRuntime.jsxs(TextFieldContainer, {
                    leadingIcon: startIcon,
                    trailingIcon: endIcon,
                    measure: measure,
                    isFocused: isFocused,
                    isError: isError,
                    isDisabled: disabled,
                    children: [
                        variant === 'lable' && jsxRuntime.jsx(LableInput, Object.assign({
                            isFixed: !!placeholder
                        }, commonProps, {
                            ref: ref
                        })),
                        variant === 'default' && jsxRuntime.jsx(InputTypeSelector, Object.assign({}, commonProps, {
                            ref: ref
                        }))
                    ]
                })
            }),
            isVisibleSupportContainer && jsxRuntime.jsx(SupportTextContainer, {
                errorMessage: errorMessage,
                supportMessage: supportMessage,
                currentLength: currentLength,
                maxLength: maxLength,
                isMaxLengthVisible: isMaxLengthVisible
            })
        ]
    });
});
TextField.displayName = 'TextField';

module.exports = TextField;
